import { useCallback } from 'react';
import useLocalStorage from 'src/hooks/useLocalstorage';
import Switch from './design-system/Switch';

const useLinkControl = (page: string) => {
  const [openNewTab, setOpenNewTab] = useLocalStorage(page, true);

  const LinkControl = useCallback(
    () => (
      <>
        <div className="flex flex-row items-center gap-2">
          <Switch
            value={openNewTab}
            onChange={(e) => setOpenNewTab(e.value)}
            onLabel="YES"
            offLabel="NO"
            size={'small'}
            className={'!w-[54px]'}
          />
          <span className="whitespace-nowrap text-sm">Open Documents in New Tab</span>
        </div>
      </>
    ),
    [openNewTab, setOpenNewTab]
  );

  return {
    LinkControl,
    openNewTab,
  };
};

export default useLinkControl;
